import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    serverError: false,
    authenticated: false,
    showBack: false,
    showNavbar: true,
    pageBack: '',
    redirectPage: 'Login',
    badgecnt: 999,
    title: 'クラウド',
    userinfo: {},
    docIndex: [],
    confirmdef: {},
    confirmdef2: {},
    editdef: {},
    postinfo: {
      id: ''
    },
    metakey: '',
    tag: '',
    taglist: [],
    baseurl: 'https://cloud.salesmini.cn',
    userAgent: '',
    platform: '',
    guest: '',
    tp: {},
    listcategory: '14',
    listcatename: '产品文档',
    searchOpt: {
      status: '1',
      category: '14'
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
